import React from "react"

import TextareaWithVariables from "../../../../gd-components/textarea-with-variables/textarea-with-variables"
import {FieldFormElementViewProps} from "../../../render/form-elemnent-view"
import FieldTextWithVariables from "../text-with-variables"

export default function FieldTextWithVariables_FormElementView(props: FieldFormElementViewProps) {

    const field    = props.field as FieldTextWithVariables
    const disabled = _.get(props.options, 'disabled', false) || _.get(props, 'disabled', false)
    const value    = props.model[props.field.fieldId] || ''

    const onChange = (text: string) => {
        props.onChange?.(text)
    }

    return (
        <TextareaWithVariables
            className   = {props.className}
            value       = {value}
            onChange    = {onChange}
            tokens      = {field.tokens}
            placeholder = {props.field.placeholder}
            disabled    = {disabled}
            rows        = {props.rows}
            singleLine  = {field.singleLine}
        />
    )
}
